import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { SharedModule } from '../../shared/shared.module';

import {UiSwitchTextModule} from './forms/toggle-switch-with-text/index';
import {Ng2SmartTableModule} from './ng2-smart-table';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {Ng2OdometerModule} from './ng2-odometer';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { Daterangepicker } from 'ng2-daterangepicker';

import {GravatarDirective} from './directives/gravatar.directive';

import {GmtPipe} from './pipes/gmt.pipe';
import {TimesPipe} from './pipes/times.pipe';

import {TimezoneComponent} from './forms/timezone/timezone.component';
import {BatteryRechargeComponent} from './general/battery-recharge/battery-recharge.component';
import {HeaderComponent} from './header/header.component';
import {ChannelRateLimitBannerDetailsDialogComponent} from './channel-rate-limit-banner-details-dialog/channel-rate-limit-banner-details-dialog.component';
import {DownloadIconComponent} from './table/download-icon/download-icon.component';
import {TableToggleSwitchTextComponent} from './table/table-toggle-switch-text/table-toggle-switch-text.component';
import {TableSettingsDeleteComponent} from './table/table-settings-delete/table-settings-delete.component';

import {D3LineComponent} from './charts/d3/d3-line.component';
import {ProgressWizardComponent} from './general/progress-wizard/progress-wizard.component';
import {ProcessWizardTextComponent} from './general/process-wizard-text/process-wizard-text.component';
import {TimezoneSelectMenuComponent} from './forms/timezone-select-menu/timezone-select-menu.component';
import {SimplePieComponent} from './charts/d3/pie/simple-pie/simple-pie.component';
import {SimpleLineComponent} from './charts/d3/line/simple-line/simple-line.component';
import {TableSubuserToggleTextComponent} from './table/table-subuser-toggle-text/table-subuser-toggle-text.component';
import {TableSettingsIconComponent} from './table/table-settings-icon/table-settings-icon.component';
import {TableDomainStatusComponent} from './table/table-domain-status/table-domain-status.component';
import {RouterModule} from '@angular/router';
import {TableStatusComponent} from './table/table-status/table-status.component';
import {NgxChartsModule} from '@swimlane/ngx-charts';
//import {SelectModule} from 'ng2-select';
import {PageAlertComponent} from './general/page-alert/page-alert.component';
import {FromNowPipe} from './pipes/from-now.pipe';
import {StripeCardComponent} from './payments/stripe-card/stripe-card.component';
import {AlertComponent} from './forms/alert/alert.component';
import {TableSettingsTextComponent} from './table/table-settings-text/table-settings-text.component';
import {CouponCodeStateComponent} from './table/coupon-code-state/coupon-code-state.component';
import {TemplateSearchPipe} from './pipes/template-search.pipe';
import {AddCommasToNumPipe} from './pipes/add-commas-to-num.pipe';
import {TableEditDeleteComponent} from './table/table-edit-delete/table-edit-delete.component';
import {TableEditComponent} from './table/table-edit/table-edit.component';
import {TablePlanStatusComponent} from './table/table-plan-status/table-plan-status.component';
import {TableCurrentPlanChangeComponent} from './table/table-current-plan-change/table-current-plan-change.component';
import {ShowHidePasswordComponent} from './forms/show-hide-password/show-hide-password.component';
import { BucketwiseSettingsIconComponent } from './table/bucketwise-settings-icon/bucketwise-settings-icon.component';
import {HelpSectionComponent} from './help-section/help-section.component';
import {TableSubaccountStatusComponent} from './table/table-subaccount-status/table-subaccount-status.component';
import { TableSubaccountAmountstatusComponent } from './table/table-subaccount-amountstatus/table-subaccount-amountstatus.component';
import { TableEditOptionComponent } from './table/table-edit-option/table-edit-option.component';
import { CapitalizeFirstPipe } from './pipes/capitalize-first.pipe';
import { TableSandboxRecpemailStatusComponent } from './table/table-sandbox-recpemail-status/table-sandbox-recpemail-status.component';
import { TableSandboxRecpStatusComponent } from './table/table-sandbox-recp-status/table-sandbox-recp-status.component';
import {DropdownSettings} from './dropdown/multiselect.interface';
import {MultiSelectComponent, MultiSelectModule} from './dropdown/multiselect.component';
import {TableSubadminStatusComponent} from "./table/table-subadmin-status/table-subadmin-status.component";
import {ContentPreviewComponent} from "./table/content-preview/content-preview.component";
import {ErrorPreviewComponent} from "./table/error-preview/error-preview.component";
import {ContentListComponent} from "./table/table-content-list/content-list.component";
import { TableTemplateStatusComponent } from './table/table-template-status/table-template-status.component';
import { TableTemplateLanguageComponent } from './table/table-template-language/table-template-language.component';
import { TableTemplateNameComponent } from './table/table-template-name/table-template-name.component';
import { TableTemplateActions } from './table/table-template-actions/table-template-language.component';
import { TablePlanPriceComponent } from './table/table-plan-price/table-plan-price.component';
import { TablePlanAnnualPriceComponent } from './table/table-plan-annual-price/table-plan-annual-price.component';
import { MobileSearchComponent } from './table/mobile-search/mobile-search.component';
import { WaMessageActionComponent } from './table/wa-message-action/wa-message-action.component';
import { TableDedicatedIpDefaultComponent } from './table/table-dedicated-ip-default/table-dedicated-ip-default.component';
import { TableDedicatedIpUnsubComponent } from './table/table-dedicated-ip-unsubscribe/table-dedicated-ip-unsubscribe.component';
import { TableDedicatedIpBatchlistComponent } from './table/table-dedicated-ip-batchlist/table-dedicated-ip-batchlist.component';
import { TableConnectionStatusComponent } from './table/table-connection-status/table-connection-status.component';
import { TableManageConnectionComponent } from './table/table-manage-connection/table-manage-connection.component';
import { TableReportScheduleComponent } from './table/table-report-schedule/table-report-schedule.component';
import { TableReportModifySettingsComponent } from './table/table-report-modify-settings/table-report-modify-settings.component';
import { TableReportLoadComponent } from './table/table-report-load/table-report-load.component';
import { TableReportDescPreviewComponent } from './table/table-report-desc-preview/table-report-desc-preview.component';
import { TableResendReportComponent } from './table/table-resend-report/table-resend-report.component';
import { TableFunnelColumnsComponent } from './table/table-funnel-columns/table-funnel-columns.component';
import { TableInsightsPercentageComponent } from './table/table-insights-percentage/table-insights-percentage.component';
import { TablePostmasterCountComponent } from './table/table-postmaster-count/table-postmaster-count.component';
import { TableEmailPreviewComponent } from './table/table-email-preview/table-email-preview.component';
import { TableNameViewComponent } from './table/table-name-view/table-name-view.component';
import { TableRowClickComponent } from './table/table-row-click/table-row-click.component';
import { SummaryCountsRedirectComponent } from './table/summary-counts-redirect/summary-counts-redirect.component';
import { PayNowComponent } from './table/pay-now/pay-now.component';
import { NewMainMenuComponent } from './new-main-menu/new-main-menu.component';
import { MatIconModule } from '@angular/material/icon';
import { CustomMenuIconService } from '../../../app/pages/services/custom-menu-icon.service';
import { HighchartsChartModule } from 'highcharts-angular';

import { NoDataComponent } from './no-data/no-data.component';
import { MoreFiltersComponent } from './forms/more-filters/more-filters.component';
import { CustomizeDashComponent } from '../components/general/customize-dash/customize-dash.component';
import { DragulaModule } from 'ng2-dragula';
import { CustomizeDropdownComponent  } from './dropdown/customize-dropdown/customize-dropdown.component';

import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { CreateApiKeyComponent } from './integration/create-api-key/create-api-key.component';
import { ApiKeyTableComponent } from './integration/api-key-table/api-key-table.component';
import { NgMatSearchBarModule } from 'ng-mat-search-bar';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { TableWaTmpActionsComponent } from './table/table-wa-tmp-actions/table-wa-tmp-actions.component';
import {ClipboardModule} from 'ngx-clipboard';
import { CampaignHeaderComponent } from './campaign-header/campaign-header.component';
import { ImageCropperModule } from '../../library/image-cropper/image-cropper.module';
import {TextEditorModule} from "./text-editor/text-editor.module";
import { ConfirmPopupComponent } from './confirm-popup/confirm-popup.component';
import { SaveExitPopupComponent } from './save-exit-popup/save-exit-popup.component';
import { RadioConfirmationPopupComponent } from './radio-confirmation-popup/radio-confirmation-popup.component';
import { MatLegacyDialogModule as MatDialogModule, MAT_LEGACY_DIALOG_DEFAULT_OPTIONS as MAT_DIALOG_DEFAULT_OPTIONS,MatLegacyDialogRef as MatDialogRef,MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/legacy-dialog";
import { DeletePopupComponent } from './delete-popup/delete-popup.component';
import { TwoFactorAuthDialogComponent } from './two-factor-auth-dialog/two-factor-auth-dialog.component';
import { SetReportPasswordRequiredDialogComponent } from './set-report-password-required-dialog/set-report-password-required-dialog.component';
import { TableValueHighlightComponent } from './table/table-value-highlight/table-value-highlight.component';
import { TestWhatsappMesssageComponent } from './test-popup/test-whatsapp-message.component';
import {MatLegacyTooltipModule as MatTooltipModule} from '@angular/material/legacy-tooltip';
import { SortDataDirective } from './directives/sort-data.directive';
import { ReportTableComponent } from './report-table/report-table.component';
import { AddUserPopupComponent } from './add-user-popup/add-user-popup.component';
import { ScheduleReportPopupComponent } from './schedule-report-popup/schedule-report-popup.component';
import { AddAlertPopupComponent } from './add-alert-popup/add-alert-popup.component';
import { WaMoreFiltersComponent } from './wa-more-filters/wa-more-filters.component';
import { WaNumberCountryFilterComponent } from './wa-number-country-filter/wa-number-country-filter.component';
import { TableMobileNumberInfoComponent } from './table/table-mobile-number-info/table-mobile-number-info.component';
import {MatLegacyMenuModule as MatMenuModule} from '@angular/material/legacy-menu';
import {MatLegacyProgressSpinnerModule as MatProgressSpinnerModule} from '@angular/material/legacy-progress-spinner';
import { WaDownloadReportComponent } from './wa-download-report/wa-download-report.component';
import { PieChartComponent } from './charts/pie-chart/pie-chart.component';
import { TableUserStatusComponent } from './table/table-user-status/table-user-status.component';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatChipsModule } from '@angular/material/chips';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { CustomChannelIconComponent } from './table/custom-channel-icon/custom-channel-icon.component';
import { WhitelistActionComponent } from './table/whitelist-action/whitelist-action.component';
import { TableBlocklistFormatNumberComponent } from './table/table-blocklist-format-number/table-blocklist-format-number.component';
import { CustomChannelIcon2Component } from './table/custom-channel-icon2/custom-channel-icon2.component';
import { TableDeleteViewComponent } from './table/table-delete-view/table-delete-view.component';
import { ScheduleReportRcsPopupComponent } from './schedule-report-rcs-popup/schedule-report-popup.component';
import { FilterChipsModule } from './filter-chips/filter-chips.module';
import { MultiWebhookComponent } from './multi-webhook/multi-webhook.component';
import { ContentEditableComponent } from './content-editable/content-editable.component';
import { CustomTooltipDirective } from './directives/custom-tooltip.directive';
import { MultiSelectDropdownComponent } from './multi-select-dropdown/multi-select-dropdown.component';
import { ClicktrackConfigComponent } from './general/settings/clicktrack-config/clicktrack-config.component';
import { SmsFiltersComponent } from './sms-filters/sms-filters.component';
import { SmsMoreFiltersComponent } from './sms-more-filters/sms-more-filters.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MultiSelectBotWrapperComponent } from './multi-select-bot-wrapper/multi-select-bot-wrapper.component';
import { TemplateEditConfirmationComponent } from './template-edit-confirmation/template-edit-confirmation.component';
import { TemplateDuplicateConfirmationComponent } from './template-duplicate-confirmation/template-duplicate-confirmation.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { PortalModule } from '@angular/cdk/portal';
import { OnlyIntegersDirective } from './directives/only-integers.directive';
import { FilterPipe } from './pipes/filter.pipe';
import { CustomMultiSelectComponent } from './custom-multi-select/custom-multi-select.component';
import { MetaOnboardingModalFBComponent } from './meta-onboarding-modal-fb/meta-onboarding-modal-fb.component';
import { ProgressModalFbComponent } from './progress-modal-fb/progress-modal-fb.component';
import { BussinessVerificationDrawerComponent } from './account-settings/bussiness-verification-drawer/bussiness-verification-drawer.component';
import { FileUploadModule } from './file-upload/file-upload.module';
import { AddWebhookDrawerComponent } from './multi-webhook/add-webhook-drawer/add-webhook-drawer.component';
import { NgxOtpInputComponent } from 'ngx-otp-input';

const formComponents = [
  TimezoneComponent,
  TimezoneSelectMenuComponent,
  StripeCardComponent,
  ShowHidePasswordComponent,
];

const customPipes = [
  GmtPipe,
  TimesPipe,
  FromNowPipe,
  TemplateSearchPipe,
  AddCommasToNumPipe,
  CapitalizeFirstPipe,
  TemplateSearchPipe,
  AddCommasToNumPipe,
];


const generalComponents = [
  BatteryRechargeComponent,
  ProgressWizardComponent,
  ProcessWizardTextComponent,
  AlertComponent,
  PageAlertComponent,
  HelpSectionComponent,
  NoDataComponent,
  CustomizeDropdownComponent,
  MoreFiltersComponent,
  CustomizeDashComponent,
  CreateApiKeyComponent,
  ApiKeyTableComponent,
];

const tableComponents = [
  DownloadIconComponent,
  TableToggleSwitchTextComponent,
  TableSettingsDeleteComponent,
  TableSubuserToggleTextComponent,
  TableEditDeleteComponent,
  TableEditComponent,
  TableSettingsIconComponent,
  TableDomainStatusComponent,
  TableStatusComponent,
  TablePlanStatusComponent,
  TableSettingsTextComponent,
  CouponCodeStateComponent,
  TableCurrentPlanChangeComponent,
  BucketwiseSettingsIconComponent,
  TableSubadminStatusComponent,
  TableSubaccountStatusComponent,
  TableSubaccountAmountstatusComponent,
  TableEditOptionComponent,
  TableSandboxRecpemailStatusComponent,
  TableSandboxRecpStatusComponent,
  ContentPreviewComponent,
  ErrorPreviewComponent,
  MobileSearchComponent,
  WaMessageActionComponent,
  ContentListComponent,
  TableTemplateStatusComponent,
  TableTemplateLanguageComponent,
  TableTemplateNameComponent,
  TableTemplateActions,
  TablePlanPriceComponent,
  TablePlanAnnualPriceComponent,
  TableDedicatedIpDefaultComponent,
  TableDedicatedIpUnsubComponent,
  TableDedicatedIpBatchlistComponent,
  TableConnectionStatusComponent,
  TableDeleteViewComponent,
  TableManageConnectionComponent,
  TableReportScheduleComponent,
  TableReportModifySettingsComponent,
  TableReportLoadComponent,
  TableReportDescPreviewComponent,
  TableResendReportComponent,
  TableFunnelColumnsComponent,
  TableInsightsPercentageComponent,
  TablePostmasterCountComponent,
  TableRowClickComponent,
  SummaryCountsRedirectComponent,
  PayNowComponent,
  TableEmailPreviewComponent,
  TableNameViewComponent,
  TableWaTmpActionsComponent,
  TableValueHighlightComponent,
  TableMobileNumberInfoComponent,
  TableUserStatusComponent,
  CustomChannelIconComponent,
  CustomChannelIcon2Component,
  WhitelistActionComponent,
  TableBlocklistFormatNumberComponent

];

const directives = [
  GravatarDirective,
  SortDataDirective
];

const charts = [
  D3LineComponent,
  SimplePieComponent,
  SimpleLineComponent,
];

const matFormsModules = [
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,

]

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    UiSwitchTextModule,
    Ng2SmartTableModule,
    NgxChartsModule,
    NgMatSearchBarModule,
    MatRadioModule,
    MatCheckboxModule,
    NgbModule,
    MatDialogModule,
    Ng2OdometerModule,
    DragulaModule,
    //SelectModule,
    MultiSelectModule,
    MatIconModule,
    TextEditorModule,
    Daterangepicker,
    HighchartsChartModule,
    ClipboardModule,
    ImageCropperModule,
    MatTooltipModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatDatepickerModule,
    MatChipsModule,
    MatNativeDateModule,
    FilterChipsModule,
    MatProgressSpinnerModule,
    ...matFormsModules,
    NgxDaterangepickerMd.forRoot(),
    ScrollingModule,
    OverlayModule,
    PortalModule, 
    SharedModule,
    FileUploadModule,
    // ngx-otp-input is a standalone component (Angular 14+). Import it here to use in declared components.
    NgxOtpInputComponent
  ],
  declarations: [
    HeaderComponent,
    ChannelRateLimitBannerDetailsDialogComponent,
    ...formComponents,
    ...customPipes,
    ...generalComponents,
    ...tableComponents,
    ...directives,
    ...charts,
    TableDedicatedIpUnsubComponent,
    TableDedicatedIpBatchlistComponent,
    NewMainMenuComponent,
    TableRowClickComponent,
    SummaryCountsRedirectComponent,
    CampaignHeaderComponent,
    ConfirmPopupComponent,
    SaveExitPopupComponent,
    RadioConfirmationPopupComponent,
    DeletePopupComponent,
    TwoFactorAuthDialogComponent,
    SetReportPasswordRequiredDialogComponent,
    TestWhatsappMesssageComponent,
    SortDataDirective,
    ReportTableComponent,
    AddUserPopupComponent,
    ScheduleReportPopupComponent,
    AddAlertPopupComponent,
    WaMoreFiltersComponent,
    WaNumberCountryFilterComponent,
    PieChartComponent,
    WaDownloadReportComponent,
    ScheduleReportRcsPopupComponent,
    MultiWebhookComponent,
    ContentEditableComponent,
    CustomTooltipDirective,
    ClicktrackConfigComponent,
    MultiSelectDropdownComponent,
    SmsFiltersComponent,
    SmsMoreFiltersComponent,
    MultiSelectBotWrapperComponent,
    OnlyIntegersDirective,
    FilterPipe,
    CustomMultiSelectComponent,
    TemplateEditConfirmationComponent,
    TemplateDuplicateConfirmationComponent,
    MetaOnboardingModalFBComponent,
    ProgressModalFbComponent,
    BussinessVerificationDrawerComponent,
    AddWebhookDrawerComponent,
    // OptInOptOutComponent
  ],
  exports: [
    NgbModule,
    Ng2OdometerModule,
    Ng2SmartTableModule,
    NgxChartsModule,
    TextEditorModule,
    UiSwitchTextModule,
    HeaderComponent,
    //SelectModule,
    ...formComponents,
    ...customPipes,
    ...generalComponents,
    ...tableComponents,
    ...directives,
    ...charts,
    FilterChipsModule,
    MultiSelectModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    NewMainMenuComponent,
    ReactiveFormsModule,
    CampaignHeaderComponent,
    TestWhatsappMesssageComponent,
    SaveExitPopupComponent,
    RadioConfirmationPopupComponent,
    AddUserPopupComponent,
    ScheduleReportPopupComponent,
    AddAlertPopupComponent,
    WaMoreFiltersComponent,
    WaNumberCountryFilterComponent,
    PieChartComponent,
    WaDownloadReportComponent,
    ImageCropperModule,
    DeletePopupComponent,
    ReportTableComponent,
    ScheduleReportRcsPopupComponent,
    MultiWebhookComponent,
    ContentEditableComponent,
    ClicktrackConfigComponent,
    MultiSelectDropdownComponent,
    SmsFiltersComponent,
    SmsMoreFiltersComponent,
    MultiSelectBotWrapperComponent,
    OnlyIntegersDirective,
    FilterPipe,
    CustomMultiSelectComponent,
    TemplateEditConfirmationComponent,
    TemplateDuplicateConfirmationComponent,
    MetaOnboardingModalFBComponent,
    ProgressModalFbComponent,
  ],
  providers: [
    CustomMenuIconService,
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: true } },
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
    MatDatepickerModule
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class ComponentsModule {
}
